module.exports = __webpack_public_path__ + "static/media/sm.2352f25c.svg";